import React from "react";
import CommunityEditPage from "../community/components/CommunityEditPage";
import { ASK_FOR_HELP } from "../community/constants";

export default function EditAskForHelpPage() {
  return <CommunityEditPage section={ASK_FOR_HELP} />;
}
